// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CheckType,
  CheckOption,
  CheckGrading,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  checkId: __t.string().name("check_id"),
  stepId: __t.string().name("step_id"),
  projectId: __t.string().name("project_id"),
  beat: __t.u32(),
  get checkType() {
    return CheckType.name("check_type");
  },
  question: __t.string(),
  get options() {
    return __t.array(CheckOption);
  },
  multiSelect: __t.bool().name("multi_select"),
  shuffleOptions: __t.bool().name("shuffle_options"),
  retryLimit: __t.option(__t.u32()).name("retry_limit"),
  timeLimitSeconds: __t.option(__t.u32()).name("time_limit_seconds"),
  showCorrectAnswer: __t.bool().name("show_correct_answer"),
  sequenceOrder: __t.u32().name("sequence_order"),
  get grading() {
    return CheckGrading;
  },
});
